import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { FlagTransparentIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { ReportAbuseLink as ReportAbuseLinkSunrise } from 'src/app/shared/components/abuseSunrise';

export const ReportAbuseContainerSunrise: React.FC = () => {
	const {
		data: {
			petition: { id, slug },
		},
	} = usePetitionDetailsPageData();

	return (
		<div className="pt-9" data-qa="report-abuse-section">
			<ReportAbuseLinkSunrise type="petition" petitionId={id} petitionSlug={slug} v2>
				<button type="button" className="flex items-center gap-1">
					<FlagTransparentIcon size={14} className="text-black" />
					<Text className="text-typography-strong underline" size="small">
						<Translate value="fe.components.petition_report_abuse.report_link" />
					</Text>
				</button>
			</ReportAbuseLinkSunrise>
		</div>
	);
};
